export default {
  subject: (enhancedLease) => `Renewal Invitation`,
  body: (enhancedLease) => `
  <p><em>Dear ${enhancedLease.tenantNames}:</em></p>

  <p>Congraduartions to have the oppotunity to live at ${enhancedLease.showStreetAddress}.</p>

  <p>Please find out the contract from the attachment and fill it back to me and then all things will be done.</p>

  <p>Have a good day!</p>

<p>Your tenant agant,</p>
<p>Unity Property Management</p>
  `,
}
